<template>
	<div class="card">
        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
          	<div class="text-muted fs-19 d-flex justify-content-start">
		   		<strong>Financeiro</strong>
		  	</div>
		  	<bsh-dropdown-nav
		  		id="dropdownFinanceiro"
		  		:tabs="tabs"
		  		:ativo="2"
		  		@navChanged="ChangeChart">
		  	</bsh-dropdown-nav>
        </div>
        <div class="card-body">
			<chart 
				:key="chartKey"
				:data="config"
				identify="financeiroChartBar"
				width="100%"
				height="40">
			</chart>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				screen: 0,
				tabs: [
		            {
		              	label: 'Semana',
		              	field: 'semana3',
		            },
		            {
		              	label: 'Mês',
		              	field: 'mes3'
		            },
		            {
		            	label: 'Ano',
		              	field: 'ano3',
		            },
				],
				dados: [],
				datasets: [],
				config: [],
				labels: [],
				chartKey: 1,
			}
		},
		created(){
			this.getDados();
			this.labels = this.setLabelAno();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/financeiro/chart?data='+this.date)
	            .then(response => {
	            	this.dados = response.data.bar
					this.ChangeChart('ano3')
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			ChangeChart(chartPeriod){
				this.datasets = [];
				if(chartPeriod == 'ano3'){
					this.labels = this.setLabelAno();
					this.datasets = this.dados.financeiro_mes_ano;
				}
				if(chartPeriod == 'mes3'){
					this.labels = this.setLabelMes();
					this.datasets = this.dados.financeiro_dia_mes;
				}
				if(chartPeriod == 'semana3'){
					this.labels = this.setLabelSemana();
					this.datasets = this.dados.financeiro_dia_semana;
				}
				this.chartKey += 1;
				this.setConfig();
				this.setChart();
			},
			setChart(){
				Chart.defaults.global.defaultFontFamily = '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
				Chart.defaults.global.defaultFontColor = '#292b2c';

				var ctx = document.getElementById('financeiroChartBar').getContext('2d');
				var PieChart = new Chart(ctx, this.config);
			},
			setLabelAno(){
				return [
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez'
				];
			},
			setLabelMes(){
				var date = new Date();
				var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				var dia_fim = ultimoDia.getDate();
				var result = [];
				for(var i=1; i<=dia_fim; i++){
					result.push(String(i));
				}	
				return result;
			},
			setLabelSemana(){
				return [
					'Dom',
					'Seg',
					'Ter',
					'Qua',
					'Qui',
					'Sex',
					'Sab'
				];
			},
			setConfig(){
				this.config = {
					type: 'bar',
					data: {
						datasets: [
							{
								data: this.datasets.receita,
								backgroundColor: "rgba(41,155,7,1)",
								label: 'Receita'
							},
							{
								data: this.datasets.despesa,
								backgroundColor: "rgba(228,15,15,1)",
								label: 'Despesa'
							}
						],
						labels: this.labels
					},
					options: {
						responsive: true,
						scales: {
				      		xAxes: [
				      			{
				        			time: {
				          				unit: 'date'
				        			},
				        			gridLines: {
				          				display: false
				        			},
				        			ticks: {
				          				maxTicksLimit: 32
				        			}
				      			}
				      		],
				      		yAxes: [{
				        		ticks: {
				          			min: 0,
				          			maxTicksLimit: 5,
				          			callback: function(value) {
									    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
									}
				        		}
				      		}],
				    	},
				    	tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
							    	return tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
							  	}
							}
						}
					}
				};
			}
		}
	}
</script>